import React from "react";
import {useTranslation} from "react-i18next";

import Button from "@mui/material/Button";
import { Send as SendIcon } from "@vedmarket/ui-kit";

import {useCreateSupportTicketMutation} from "../../../../../../../api/support";
import {SUPPORT_TICKET_CREATE_CACHE_KEY} from "../../../../support-constants";

import './support-request-actions.scss'

type Props = {
  formId: string
  onCancel(): void;
}

const SupportRequestActions = ({formId, onCancel}: Props) => {

  const { t } = useTranslation();

  const [ , {isLoading} ] = useCreateSupportTicketMutation({
    fixedCacheKey: SUPPORT_TICKET_CREATE_CACHE_KEY,
  });

  return (
    <div className='support-request-actions'>
      <Button variant='outlined' onClick={onCancel} sx={{cursor: 'pointer', height: '40px', padding: '8px 24px'}}>
        {t('actions__text__cancel')}
      </Button>
      <Button
        type='submit'
        form={formId}
        disabled={isLoading}
        variant='contained'
        startIcon={<SendIcon />}
        sx={{cursor: 'pointer', height: '40px', padding: '8px 24px'}}
      >
        {t('support__action__createRequest')}
      </Button>
    </div>
  );
};

export default SupportRequestActions;
